import app from './app'
import auth from './auth'
import fs from './fs'

export const apis = { app, auth, fs }
